import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditGridColumns = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Vector",
		transform: "matrix(.90548 0 0 .90547 -.82413 2.3049)",
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "m18.865 5.2468.9398-.94666c.5162-.52 1.35-.52 1.8662 0l.9398.94666c.5162.52.5162 1.36 0 1.88l-.9398.94667zm-.9397.94667-7.015 7.0667v2.8266h2.806l7.015-7.0666z" }), /* @__PURE__ */ _jsx("path", { d: "m5.8513.91016v15h3.1176v-15zm-1.8235 0v15h-3.1176l1e-6-15zm9.8824 1e-6v5.5455l-3.1177 2.9546v-8.5z" })]
	})]
});
const ForwardRef = forwardRef(SvgEditGridColumns);
export { ForwardRef as ReactComponent };
